import { getAccessTokenSilently } from "@shuttlerock/auth";
import { ConfigService } from "@shuttlerock/configuration";
import { GraphQLClient } from "graphql-request";

export const gqlClient = new GraphQLClient(ConfigService.SUPERGRAPH_BASE_URL(), {
  async requestMiddleware(request) {
    const name = "src-web";
    const version = ConfigService.APP_VERSION();
    const locale = localStorage.getItem("i18nextLng");
    const { accessToken } = await getAccessTokenSilently();

    return {
      ...request,
      headers: {
        ...request.headers,
        ...(accessToken && { authorization: `Bearer ${accessToken}` }),
        ...(locale && { "Accept-Language": locale }),
        ...(version && { "apollographql-client-version": version }),
        "apollographql-client-name": name,
        "x-client-id": [name, version].filter(Boolean).join(";"),
        accept: "application/graphql-response+json",
        "content-type": "application/json",
      },
    };
  },
});
